<app-carousel> </app-carousel>

<div class="wrapper" [ngClass.xs]="{ xs: true }">
  <ng-container
    *ngIf="
      init && (isOnline$ | async) !== null && (isOnline$ | async) === false
    "
  >
    <app-offline-message></app-offline-message>
  </ng-container>

  <h2
    class="mat-headline"
    *ngIf="mediaObserver.isActive('lt-md') || isTablet"
    style="text-align: center; margin-top: 25px"
  >
    <button
      style="text-align: center; margin: 20px"
      (click)="openMenu()"
      aria-label="Открыть боковое меню"
      mat-raised-button
      color="primary"
      style="padding: 10px; font-size: 1.5rem"
    >
      Открыть меню
    </button>
  </h2>

  <app-rolls-of-day></app-rolls-of-day>

  <h2 class="mat-headline" style="text-align: center; margin: 25px 0">
    <button
      routerLink="/discounts"
      aria-label="Открыть сраницу с акциями и скидками"
      mat-raised-button
      color="primary"
      style="font-size: 1.5rem; padding: 10px 25px"
    >
      Наши акции и скидки
    </button>
  </h2>
  <app-info-features></app-info-features>

  <div class="terms">
    <h3>Условия доставки:</h3>
    <h4>Время доставки: 11:00 - 21:45</h4>
    <p>К КАЖДОМУ ЗАКАЗУ ПЛЮС доставка 50 РУБЛЕЙ!</p>

    <p>
      Друзья! При заказе впервые мы просим предоплату в размере 300 рублей.
      Спасибо за понимание <span class="color-red">❤</span>
    </p>

    <strong>• Условия бесплатной доставки:</strong>
    <ul>
      <li>Орбита- от 800 руб</li>
      <li>Город- от {{ minOrderSum }} руб</li>
      <li>Верхний Чов и Нижний Чов - от 1200 рублей</li>
      <li>Эжва — от 1500 рублей</li>
      <li>Эжва Строитель — от 2000 руб.</li>
      <li>Максаковка — от 3000 рублей</li>
      <li>Затон- от 3000 руб</li>
      <li>Яг Кар- от 3500 рублей</li>
      <li>Лесозавод - от 1700 руб</li>
      <li>Чит- от 1700 руб</li>
      <li>Выльгорт - от 2000 руб</li>
      <li>Пичипашня - от 2500 рублей</li>
    </ul>

    <p>Дачи до бензиновой заправки- от 1000 руб.</p>
    <p>
      Дачи от бензиновой заправки до Нивы-от 1500 руб (Север, ЧерБерезка,
      Черемушки, 1ое Сыктывкарское, Верба, Дружба, Рябина, Ручеек , Чернобыль
      и тд)
    </p>

    <p>&nbsp;</p>
    <strong>* Платная доставка:</strong>
    <p>По городу &mdash; 200 руб</p>
    <p>Ближняя/Дальняя Орбита- 200 руб.</p>
    <p>Дор участок- 200 руб.</p>
    <p>Лесозавод, Кочпон Чит &mdash; 300 руб</p>
    <p>Выльгорт &mdash; 350 руб</p>
    <p>Нижний и Верхний Чов &mdash; 300 руб</p>
    <p>Краснозатонский, Эжва, Максаковка &mdash; 500 руб</p>
  </div>
</div>
